import React, { useState } from "react";

/**
 * Image with a shimmer skeleton placeholder that fades out once the image
 * loads. The skeleton is an overlay, so the <img>'s own classes (e.g. hover
 * scale transitions) are left untouched.
 *
 * `className` styles the <img> (as before). `wrapperClassName` styles the
 * positioned wrapper — pass the sizing/rounding so the skeleton matches the
 * final image box.
 */
const SmartImage = ({
  src,
  alt = "",
  className = "",
  wrapperClassName = "",
  loading = "lazy",
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <span className={`relative block overflow-hidden ${wrapperClassName}`}>
      <img
        src={src}
        alt={alt}
        loading={loading}
        onLoad={() => setLoaded(true)}
        className={className}
        {...rest}
      />
      <span
        aria-hidden="true"
        className={`skeleton pointer-events-none absolute inset-0 transition-opacity duration-500 ${
          loaded ? "opacity-0" : "opacity-100"
        }`}
      />
    </span>
  );
};

export default SmartImage;
